import React, { useState } from "react";
import FoodList from "./food-list";
import { dateStringAddDays } from "../../util";
import moment from "moment";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import Modal from "../../../../../../components/modal";
import { DayPicker } from "react-day-picker";

const Timeline = (props) => {
  const [show, setShow] = useState(false);
  const [day, setDay] = useState(false);
  const macroData = props.macroData;
  const trackerData = props.trackerData;
  const selectDate = props.selectDate;

  const getDisplayLabel = (selectedDay) => {
    return moment(selectedDay).calendar(null, {
      sameDay: "[Today], MMM Do",
      nextDay: "[Tomorrow], MMM Do",
      nextWeek: "ddd, MMM Do",
      lastDay: "[Yesterday], MMM Do",
      lastWeek: "ddd, MMM Do",
      sameElse: "ddd, MMM Do",
    });
  };

  const handleDayClick = (day) => {
    setDay(day);
  };

  const submit = () => {
    selectDate(moment(day).local().format("YYYY-MM-DD"));
  };

  let earliestWeighInDateString = null;
  for (let key in macroData.weighInDetails) {
    if (earliestWeighInDateString === null || key < earliestWeighInDateString) {
      earliestWeighInDateString = key;
    }
  }

  const earliestWeighInDateTemp = new Date(
    earliestWeighInDateString + "T00:00:00.000Z"
  );
  const earliestWeighInDate = new Date(
    earliestWeighInDateTemp.getUTCFullYear(),
    earliestWeighInDateTemp.getUTCMonth(),
    earliestWeighInDateTemp.getUTCDate()
  );

  return (
    <div style={{ background: "#FFF" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "12px 0px",
        }}
      >
        <Button
          color="primary"
          onClick={() => {
            if (trackerData.selectedTrackerDate > earliestWeighInDateString) {
              selectDate(dateStringAddDays(trackerData.selectedTrackerDate, -1));
            }
          }}
        >
          <Icon>arrow_back_ios</Icon>
        </Button>

        <Button onClick={() => setShow(!show)}>
          <h5 className="timeline-date-text">
            {getDisplayLabel(trackerData.selectedTrackerDate)}
          </h5>
        </Button>

        <Button
          color="primary"
          onClick={() =>
            selectDate(dateStringAddDays(trackerData.selectedTrackerDate, 1))
          }
        >
          <Icon>arrow_forward_ios</Icon>
        </Button>
      </div>
      <div style={{ marginBottom: 12 }}></div>
      <div style={{ margin: "0 auto", maxWidth: 1100 }}>
        <FoodList trackerData={trackerData} />
      </div>

      <Modal
        open={show}
        onClose={() => setShow(false)}
        title={`Select a day to jump to`}
        submitLabel="Confirm"
        handleSubmit={submit}
      >
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <DayPicker
            modifiersStyles={{ selected: { backgroundColor: "#1fc44a" } }}
            selected={day}
            onDayClick={handleDayClick}
            disabledDays={{ before: earliestWeighInDate }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default Timeline;
